import { AlertTriangle } from "lucide-react";

import { ChildMessagesStore } from "@/components/Playground/Messages/PlaceholderContainer/stores/child-messages-store";
import { cn } from "@/lib/utils";

export const MessageLevelError = ({
  messageId,
  childStore,
}: {
  messageId: string;
  childStore: ChildMessagesStore;
}) => {
  const validationErrors = childStore.getErrorsForMessage(messageId);

  return (
    <div
      className={cn(
        "flex items-center gap-2 rounded-t-lg border-b text-sm ",
        "px-3 py-2",
        "border-red-200 bg-red-50 text-red-700",
      )}
    >
      <AlertTriangle className="h-4 w-4 flex-shrink-0" />

      <div className="flex flex-col gap-1">
        <span className="font-medium">Invalid message structure</span>
        <div className="text-xs opacity-80">
          {validationErrors.map(err => (
            <div key={err.messageId}>
              {err.path.length > 0 ? `${err.path.join(".")}: ` : ""}
              {err.message}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
